import "./LevelProfile.scss";
import LevelBlock, {getLevel, LEVEL_NAMES, MAX_LEVEL} from "../LevelBlock/LevelBlock";

const LevelProfile = ({user}) => {
    const level = getLevel(user);

    return (
        <div className="pb-levels">
            <div className="pb-levels-head">
                <p className="pb-muted">Рівень вашого облікового запису:</p>
                <LevelBlock user={user} />
            </div>

            {/* сходинки рівнів: пройдені залиті, поточний світиться */}
            <ol className="pb-steps">
                { Array.from({ length: MAX_LEVEL }, (_, i) => {
                    const n = i + 1;
                    const state = n < level ? "done" : n === level ? "current" : "todo";

                    return (
                        <li key={n} className={`pb-step pb-step-${state}`}>
                            <span className="pb-step-node">
                                { state === "done"
                                    ? <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12.5l4.5 4.5L19 7.500" /></svg>
                                    : n }
                            </span>
                            <span className="pb-step-name">{ LEVEL_NAMES[n] }</span>
                        </li>
                    );
                })}
            </ol>
        </div>
    );
};

export default LevelProfile;
